"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelector = void 0;
const react_1 = __importStar(require("react"));
const react_intersection_observer_1 = require("react-intersection-observer");
const styles_1 = require("./styles");
const SPACEBAR_KEY_CODE = 'Space';
const ENTER_KEY_CODE = 'Enter';
const DOWN_ARROW_KEY_CODE = 'ArrowDown';
const UP_ARROW_KEY_CODE = 'ArrowUp';
const ESCAPE_KEY_CODE = 'Escape';
const SingleSelector = ({ options, defaultOption, onChangeHook, ariaLabel, dataCyPrefix, optionHeight = 25, optionPadding = 10, size = 'regular', renderPrefix = false, menuMaxHeight }) => {
    const originalMenuHeight = options.length * optionHeight + optionPadding * 2;
    const [selectedOption, setSelectedOption] = (0, react_1.useState)(() => {
        return defaultOption ? defaultOption : options[0];
    });
    const [menuPosition, setMenuPosition] = (0, react_1.useState)('bottom');
    const [menuHeight, setMenuHeight] = (0, react_1.useState)(originalMenuHeight);
    const [isMenuOpen, setIsMenuOpen] = (0, react_1.useState)(false);
    const { ref, inView } = (0, react_intersection_observer_1.useInView)();
    const firstMountRef = (0, react_1.useRef)(true);
    const menuRef = (0, react_1.useRef)(null);
    const controllerRef = (0, react_1.useRef)(null);
    const optionRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', handleMenuSize);
        window.addEventListener('scroll', handleMenuPosition);
        handleMenuSize();
        return () => {
            window.removeEventListener('resize', handleMenuSize);
            window.removeEventListener('scroll', handleMenuPosition);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        handleMenuPosition();
    }, [menuHeight]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (isMenuOpen) {
            window.addEventListener('click', pageClickEvent);
            let index = 0;
            options.forEach((option, i) => {
                if (option.value === selectedOption.value) {
                    index = i;
                }
            });
            optionRefs.current[index].focus();
        }
        if (!isMenuOpen && !firstMountRef.current && inView) {
            (_a = controllerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        firstMountRef.current = false;
        return () => {
            window.removeEventListener('click', pageClickEvent);
        };
    }, [isMenuOpen]);
    const handleMenuSize = () => {
        const { bottomScreenHeight, topScreenHeight } = calculateRemainingBottomAndTopHeight();
        const screenSpace = Math.max(bottomScreenHeight, topScreenHeight);
        if (menuMaxHeight) {
            setMenuHeight(Math.min(screenSpace, menuMaxHeight));
        }
        else {
            setMenuHeight(screenSpace);
        }
    };
    const handleMenuPosition = () => {
        const { bottomScreenHeight, topScreenHeight } = calculateRemainingBottomAndTopHeight();
        if (bottomScreenHeight > menuHeight) {
            setMenuPosition('bottom');
        }
        else if (topScreenHeight > menuHeight) {
            setMenuPosition('top');
        }
        else {
            setMenuPosition(bottomScreenHeight > topScreenHeight ? 'bottom' : 'top');
        }
    };
    const pageClickEvent = (e) => {
        if (menuRef.current !== null && !menuRef.current.contains(e.target)) {
            setIsMenuOpen(!isMenuOpen);
        }
    };
    const handleOptionClick = (option) => {
        setSelectedOption(option);
        onChangeHook === null || onChangeHook === void 0 ? void 0 : onChangeHook(option);
        setIsMenuOpen(!isMenuOpen);
    };
    const handleControlKeyDown = (e) => {
        const keyCode = e.code;
        if ([SPACEBAR_KEY_CODE, ENTER_KEY_CODE, DOWN_ARROW_KEY_CODE, UP_ARROW_KEY_CODE].includes(keyCode)) {
            e.preventDefault();
            setIsMenuOpen(true);
        }
    };
    const handleOptionKeyDown = (e, option, index) => {
        e.preventDefault();
        switch (e.code) {
            case SPACEBAR_KEY_CODE:
            case ENTER_KEY_CODE:
                handleOptionClick(option);
                return;
            case DOWN_ARROW_KEY_CODE:
                optionRefs.current[Math.min(options.length - 1, index + 1)].focus();
                return;
            case UP_ARROW_KEY_CODE:
                optionRefs.current[Math.max(0, index - 1)].focus();
                return;
            case ESCAPE_KEY_CODE:
                setIsMenuOpen(false);
                return;
            default:
                return;
        }
    };
    const calculateRemainingBottomAndTopHeight = () => {
        const windowHeight = window.innerHeight;
        const selectOffSetBottom = controllerRef.current ? controllerRef.current.getBoundingClientRect().bottom : 0;
        const selectOffSetTop = controllerRef.current ? controllerRef.current.getBoundingClientRect().top : 0;
        const bottomScreenHeight = windowHeight - selectOffSetBottom;
        const topScreenHeight = selectOffSetTop;
        return { bottomScreenHeight, topScreenHeight };
    };
    return (react_1.default.createElement(styles_1.SelectContainer, { "aria-label": ariaLabel, fullWidth: size === 'large' },
        react_1.default.createElement(styles_1.ControllerContainer, { ref: (el) => {
                controllerRef.current = el;
                ref(el);
            }, tabIndex: 0, "data-cy": `${dataCyPrefix}-selector`, onClick: () => setIsMenuOpen(!isMenuOpen), onKeyDown: handleControlKeyDown },
            size === 'large' ? (react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.AriaLabelContainer, null,
                    ariaLabel,
                    ":"),
                react_1.default.createElement("span", { style: { lineHeight: '20px' } }, selectedOption.label))) : renderPrefix ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.PrefixLabelContainer, null,
                    ariaLabel,
                    ":"),
                react_1.default.createElement("span", null, selectedOption.label))) : (react_1.default.createElement("span", null, selectedOption.label)),
            react_1.default.createElement("i", { className: "a-icon a-icon-dropdown" })),
        react_1.default.createElement(styles_1.MenuContainer, { isMenuOpen: isMenuOpen, ref: menuRef, menuPosition: menuPosition, menuHeight: menuHeight, "data-cy": `${dataCyPrefix}-dropdown-menu`, fullWidth: size === 'large' },
            react_1.default.createElement("ul", { role: "listbox", "aria-multiselectable": "false" }, options.map((option, i) => (react_1.default.createElement(styles_1.StyledOption, { ref: (el) => optionRefs.current.push(el), tabIndex: 0, role: "option", key: `option-${i}`, value: option.value, isActive: selectedOption.value === option.value, "data-cy": `${dataCyPrefix}-option-${i}`, isNotValid: option.isNotValid, onKeyDown: (e) => handleOptionKeyDown(e, option, i), onClick: () => handleOptionClick(option) }, option.label)))))));
};
exports.SingleSelector = SingleSelector;
